import HistoryJobs from "../../views/modules/HistoryJobs/HistoryJobs.vue";
import HisotryjobsDirections from "../../views/modules/HistoryJobs/HistoryJobsDirections/HistoryJobsDirections.vue";
import layouts from "../../layout";

export default {
  path: "/HistoryJobs",
  name: "HistoryJobs",
  component: HistoryJobs,
  meta: {
    auth: true
  },
  redirect: {
    name: "HistoryJobs-documentTB"
  },
  children: [
    {
      path: "HistoryJobs",
      name: "HistoryJobs-documentTB",
      component: HisotryjobsDirections,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Documents",
        tags: ["legaltb", "documents"],
        index: true
      }
    }
  ]
};
